import pako from "pako";

export function compressData(data: string): Uint8Array<ArrayBuffer> {
  console.log("[Compression] compressData 开始");
  console.log("[Compression] 原始数据长度:", data.length);

  try {
    const compressed = pako.gzip(data, { level: 6 });
    const result = new Uint8Array(compressed);
    console.log("[Compression] 压缩成功，压缩后长度:", result.length);
    console.log("[Compression] 压缩率:", ((1 - result.length / data.length) * 100).toFixed(2) + '%');
    return result;
  } catch (error) {
    console.error("[Compression] 压缩失败:", error);
    throw error;
  }
}

export function decompressData(data: Uint8Array): string {
  const decompressed = pako.ungzip(data, { to: "string" });
  return decompressed;
}

export function calculateCompressionRatio(
  original: number,
  compressed: number
): number {
  return ((original - compressed) / original) * 100;
}
